module.exports = __webpack_public_path__ + "static/parasa-9e3d6b0a1826f1f32afe639b50858d0e.jpg";